import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense, type ReactNode} from 'react'
import {MiniStatusSkeletonItem} from './MiniMergeStatusLoading'
import {MiniMergeStatusItem} from './MiniMergeStatusItem'

type MiniMergeStatusBoundaryProps = {
  action: (returnFocusTo?: HTMLElement | null) => void
  actionLabel: string
  boundaryName: string
  children: ReactNode
  text: string
}

export function MiniMergeStatusBoundary({
  action,
  actionLabel,
  boundaryName,
  children,
  text,
}: MiniMergeStatusBoundaryProps) {
  return (
    <ErrorBoundary
      boundaryName={boundaryName}
      fallback={<MiniMergeStatusErrorItem action={action} actionLabel={actionLabel} text={text} />}
    >
      <Suspense fallback={<MiniStatusSkeletonItem text={text} action={action} />}>{children}</Suspense>
    </ErrorBoundary>
  )
}

function MiniMergeStatusErrorItem({
  action,
  actionLabel,
  text,
}: Omit<MiniMergeStatusBoundaryProps, 'boundaryName' | 'children'>) {
  const unavailableText = `${text} unavailable`

  return (
    <MiniMergeStatusItem aria-label={text}>
      <MiniMergeStatusItem.LabelRow aria-label={actionLabel} onClick={event => action(event.currentTarget)}>
        <MiniMergeStatusItem.Label icon="error">{unavailableText}</MiniMergeStatusItem.Label>
      </MiniMergeStatusItem.LabelRow>
      <MiniMergeStatusItem.Progress
        aria-label={unavailableText}
        isUnavailable={false}
        successful={0}
        total={0}
        unavailableLabel={unavailableText}
      />
    </MiniMergeStatusItem>
  )
}
